import { getEnv } from './getEnv';

export const makeSignedS3Url = (objectUrl: string): string => {
  const reportBuilderUrl =
    getEnv('REACT_APP_REPORTS_URL') || `${getEnv('REACT_APP_API_URL')}/report-builder`;
  return `${reportBuilderUrl}/api/s3/signed?url=${objectUrl}`;
};
